// Move all imports to the top
import axiosInstance from '../axiosInstance';

// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';
export const ORG_DATA = 'ORG_DATA';

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';


export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const REPORT_DATA_ADDED = 'REPORT_DATA_ADDED';


// action - report allocation (newly added)
export const ASSIGN_REPORT_TO_CARD = 'ASSIGN_REPORT_TO_CARD';  // New action type for assigning reports

// Action creator for assigning reports
export const assignReportToCard = (assignments) => { 
    return {
        type: ASSIGN_REPORT_TO_CARD,
        payload: assignments,
    };
};

// Fetch reports action
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';

export const fetchReports = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get('YOUR_API_ENDPOINT');
    dispatch({ type: FETCH_REPORTS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error('Error fetching reports', error);
  }
};
